import React from 'react';

function Message(props) {
  const classes = `alert ${props.messageClass}`;
  return (
    <div id="message" className={ classes } role="alert">{ props.message }</div>
  )
}

export default Message;



/** WEBPACK FOOTER **
 ** ./src/components/presentational/Message.jsx
 **/